import React from 'react';
import SemanticHeader from '../Chapter/semantic-header';

const Iframe = ({
  title,
  src,
  caption,
  className,
  heading,
  isH3,
  isStandingVideo,
  hideTitle,
  hideCaption,
  isGallery,
  galleryLink,
}) => {
  return (
    <>
      {heading && !hideTitle && !isGallery && (
        <SemanticHeader className={`${className}__heading`} isH3={isH3}>
          {heading}
        </SemanticHeader>
      )}
      <div
        className={`${className} ${isStandingVideo ? 'standing' : ''} ${
          isGallery ? 'gallery' : ''
        }`}
      >
        <div className={`${className}__container`}>
          <iframe
            title={title}
            src={src}
            allow="encrypted-media"
            allowFullScreen
            sandbox="allow-scripts allow-same-origin allow-presentation"
          ></iframe>
        </div>
        <div className={`${className}__container__wrapper`}>
          {heading && !hideTitle && isGallery && (
            <SemanticHeader className={`${className}__heading`} isH3={isH3}>
              {heading}
            </SemanticHeader>
          )}
          {caption && !hideCaption && (
            <div className={`${className}__caption`}>
              <p>{caption}</p>
            </div>
          )}
          {galleryLink.Link && galleryLink.LinkText && (
            <div className="c-linklist">
              <a
                className="c-linklist c-anchor c-linklist__link"
                href={galleryLink.Link}
              >
                <span>{galleryLink.LinkText}</span>
              </a>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Iframe;
